module.exports = __webpack_public_path__ + "media/images/image-wrapper-8c749552f2a343305fd20e04943921af.svg";